import { NextPage } from 'next';
import Image from 'next/image';

const Login: NextPage = () => {
  return (
    <main className='max-w-3xl pt-2 mx-auto mt-16 sm:mt-24 lg:mt-32'>
      <div className='flex flex-col justify-center mb-24 text-center sm:mb-32 lg:mb-40'>
        <h1 className={`title mb-2`}>Logging into the Platform</h1>
        <p className='mb-6 body-paragraph'>
          You can log in to the Platform at the URL you signed up for.
        </p>
        <a
          href='https://support.online.church/'
          className='mb-24 underline body-paragraph text-primary hover:text-primary-hover'
        >
          Visit support for more help
        </a>
        <Image
          src='/images/login/subdomain_example.png'
          alt='Example of login'
          layout='intrinsic'
          width={1516}
          height={840}
        />
      </div>
    </main>
  );
};

export default Login;
